import { createSelector } from '@reduxjs/toolkit';
import { selectReport } from '../../selectors';

export const selectSearch = createSelector(selectReport, (reportState) => reportState.search);
export const selectParameters = createSelector(selectSearch, (searchState) => searchState.parameters);
export const selectSecurities = createSelector(selectSearch, (searchState) => searchState.securities);
export const selectSearchResults = createSelector(selectSearch, (searchState) => searchState.results);
export const selectSearchSelectedResults = createSelector(selectSearch, (searchState) => searchState.selectedResults);
export const selectModels = createSelector(selectSearch, (searchState) => searchState.models);
